import type { PropsWithChildren } from "react"
import { RelayEnvironmentProvider } from "react-relay"
import {
  Environment,
  Network,
  Observable,
  RecordSource,
  Store,
  type SubscribeFunction,
} from "relay-runtime"
import { create as createSocket } from "@absinthe/socket"
// @ts-expect-error no types
import { createFetcher, createSubscriber } from "@absinthe/socket-relay"
import { Socket as PhoenixSocket } from "phoenix"

import { domainConfig } from "@future/target/domain"

import RujiraQueryLoader from "../rujira/RujiraQueryLoader"

const rujiraGraphqlUrl = domainConfig.mainnetIndexer
  ? "wss://api.rujira.network"
  : "wss://preview-api.rujira.network"

const socket = createSocket(
  new PhoenixSocket(
    `${rujiraGraphqlUrl}/socket`,
    domainConfig.mainnetIndexer
      ? {
          params: {
            token: process.env.RUJIRA_API_KEY,
          },
        }
      : undefined,
  ),
)
const legacySubscriber = createSubscriber(socket)

const subscriber: SubscribeFunction = (request, variables, cacheConfig) => {
  return Observable.create((sink) => {
    legacySubscriber(request, variables, cacheConfig, {
      onNext: sink.next,
      onError: sink.error,
      onCompleted: sink.complete,
    })
  })
}

const fetcher = createFetcher(socket)
const network = Network.create(fetcher, subscriber)
const store = new Store(new RecordSource())
const environment = new Environment({ store, network })

const GraphqlProvider = (props: PropsWithChildren) => {
  return (
    <RelayEnvironmentProvider environment={environment}>
      <RujiraQueryLoader />
      {props.children}
    </RelayEnvironmentProvider>
  )
}

export default GraphqlProvider
